import { doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import type { OrgRole } from '@finvox/shared/org';
import { getFirestoreDb } from '@/lib/firebase';
import { assertAssignableRole } from './validation';

export async function updateOrgMemberRole(
  orgId: string,
  targetUid: string,
  role: OrgRole
): Promise<{ ok: true }> {
  assertAssignableRole(role);

  const memberRef = doc(getFirestoreDb(), 'organizations', orgId, 'members', targetUid);
  const snap = await getDoc(memberRef);
  if (!snap.exists()) throw new Error('Member not found');
  if (snap.data()?.role === 'owner') throw new Error('Cannot change owner role');

  await updateDoc(memberRef, {
    role,
    updatedAt: serverTimestamp()
  });
  return { ok: true };
}
